import { DatePipe } from '@angular/common';
import { Component, OnInit,HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';


@Component({
    selector: 'app-stoploss-pesquisa',
    templateUrl: './stoploss-pesquisa.component.html',
    styleUrls: ['./stoploss-pesquisa.component.css'],
    standalone: false
})
export class StoplossPesquisaComponent implements OnInit {

  public pesquisaForm: UntypedFormGroup;
  public cnpjUsuario: string;
  public agenteFinanceiro: AgenteFinanceiro;
  public agentesFinanceiros: AgenteFinanceiro[] = [];
  public podeEscolherAgente: boolean;
  public tranches: Tranche[];
  public ideTranche: number;

  public agenteFinanceiroPesquisa: AgenteFinanceiro;
  public janelaReferenciaPesquisa: string;
  public refresh = 0;

  constructor(
      private formBuilder: UntypedFormBuilder,
      private permissaoService: PermissaoService,
      private bnUsuarioService: BnUsuarioService,
      private service: DominiosService,
      private datePipe: DatePipe,
      private activatedRoute: ActivatedRoute,
      private trancheService: TrancheService) {
  }
  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent){
    this.buscar()
  }

  public ngOnInit() {
      this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
          this.podeEscolherAgente = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO]);

          this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; //resolver
          if (this.podeEscolherAgente) {
              this.atribuiAgenteFinanceiro(-1);
          } else {
              this.bnUsuarioService.usuario$.subscribe(usuario => {
                  if (usuario) {
                      this.cnpjUsuario = usuario.cnpj;
                      this.atribuiAgenteFinanceiro(this.cnpjUsuario);
                  }
              });
          }

          this.trancheService.getTranches().subscribe (tranches => {
            this.tranches = tranches;
          });

      });

      this.pesquisaForm = this.formBuilder.group({
          nomeJanela: [moment().subtract(1, 'months').toDate(), [Validators.required]],
          tranche: ['', [Validators.required]],
      });
   }

  atribuiAgenteFinanceiro(cnpj) {
      if (!cnpj) {
          this.agenteFinanceiro = undefined;
      } else if (cnpj == -1) { // Todos
          this.agenteFinanceiro = new AgenteFinanceiro();
          this.agenteFinanceiro.id = -1;
      } else {
          for (const agente of this.agentesFinanceiros) {
              if (agente.cnpj === cnpj) {
                  this.agenteFinanceiro = agente;
              }
          }
      }
  }

  atribuiTranche(ide) {
    this.ideTranche = ide;
  }

  buscar() {
    if(this.ideTranche && this.pesquisaForm.valid){
      this.agenteFinanceiroPesquisa = this.agenteFinanceiro;
      this.janelaReferenciaPesquisa = this.datePipe.transform(this.pesquisaForm.get('nomeJanela').value, 'MM/yyyy');
      this.refresh++;
    }
  }

  compararPorId(item1: string, item2: string): boolean {
    return item1 && item2 ? item1 === item2 : !item1 && !item2;
  }
}
